(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("@apg-stats/apg-core", ["react"], factory);
	else if(typeof exports === 'object')
		exports["@apg-stats/apg-core"] = factory(require("react"));
	else
		root["@apg-stats/apg-core"] = factory(root["react"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 